/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Ledger_All_KindsInputs */



/**
* | output |
* | --- |
* | "All kinds" |
*
* @param {Promo_Ledger_All_KindsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_ledger_all_kinds = /** @type {((inputs?: Promo_Ledger_All_KindsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Ledger_All_KindsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous les types")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los tipos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todos os tipos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti i tipi")
	return /** @type {LocalizedString} */ ("All kinds")
});